"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserS3Provider = exports.normalizeChannelOverrides = exports.isEntityOverridesFromAPI = exports.isChannelOverridesFromAPI = exports.ENTITY_ORDER = void 0;
const http = __importStar(require("./http"));
const is = __importStar(require("../is"));
const types_1 = require("../types");
const flatten_namespace_1 = __importDefault(require("../flatten-namespace"));
const z = __importStar(require("myzod"));
const CDN_URL = 'https://ensign.unbounce.com';
/**
 * Arrange by order to specificity. This is the order that overrides will be applied in
 * if there is a conflict (where higher index in the array takes precedence).
 */
exports.ENTITY_ORDER = [types_1.Entity.Accounts, types_1.Entity.Clients, types_1.Entity.Users, types_1.Entity.Pages];
/**
 * The expected response from the CDN when fetching channel overrides.
 */
const ChannelOverridesFromAPI = z.record(types_1.NamespacedFeatureValues);
/**
 * The expected response from the CDN when fetching entity-specific overrides.
 */
const EntityOverridesFromAPI = z.object({ channels: z.array(z.string()).optional() }).and(types_1.NamespacedFeatureValues);
/**
 * The expected shape of the CDN response object
 */
const APIResponse = z.object({
    channelOverrides: z.unknown(),
    contextOverrides: z.record(z.unknown()),
}, { allowUnknown: true });
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isPrototype = () => typeof window !== 'undefined' && !!window.Prototype;
/**
 * Verifies the shape of the channel overrides CDN response object.
 */
const isChannelOverridesFromAPI = (obj) => isPrototype() || is.isValid(ChannelOverridesFromAPI.try(obj));
exports.isChannelOverridesFromAPI = isChannelOverridesFromAPI;
/**
 * Verifies the shape of an entity overrides CDN response object.
 */
const isEntityOverridesFromAPI = (obj) => isPrototype() || is.isValid(EntityOverridesFromAPI.try(obj));
exports.isEntityOverridesFromAPI = isEntityOverridesFromAPI;
/**
 * * Fetches overrides for a given context.
 * @param app The name of the Ensign application
 * @param environment The environment for which we're fetching this, e.g. "production".
 * @param context The context for which the entities should be fetched.
 */
const fetchPublicOverrides = async (app, environment, context) => {
    const contextQueryString = Object.values(types_1.Entity)
        .reduce((acc, key) => {
        const id = context[key];
        return id ? [...acc, `${key}=${id}`] : acc;
    }, [])
        .join('&');
    const url = `${CDN_URL}/public-overrides?env=${environment}&app=${app}&${contextQueryString}`;
    const rawResponse = await http.get(url);
    return APIResponse.parse(rawResponse);
};
const normalizeChannelOverrides = (input) => {
    const overrides = { stable: {}, custom: {} };
    if (!(0, exports.isChannelOverridesFromAPI)(input)) {
        console.warn(`Channel overrides are malformed.`, '\n' + JSON.stringify(input, null, 2));
    }
    else {
        for (const channelName in input) {
            if (channelName === 'stable') {
                overrides.stable = (0, flatten_namespace_1.default)(input.stable);
            }
            else {
                const channel = input[channelName];
                overrides.custom[channelName] = (0, flatten_namespace_1.default)(channel);
            }
        }
    }
    return overrides;
};
exports.normalizeChannelOverrides = normalizeChannelOverrides;
const normalizeContextOverrides = (input) => {
    return Object.keys(input).reduce((acc, selector) => {
        const [entityName, entityId] = selector.split(':');
        const overrides = input[selector];
        const result = {
            entity: entityName,
            id: -1,
            channels: [],
            overrides: {},
        };
        if (!entityId || !exports.ENTITY_ORDER.includes(entityName)) {
            console.warn(`Found bad selector "${selector}" in context overrides.`);
        }
        else if (!(0, exports.isEntityOverridesFromAPI)(overrides)) {
            console.warn(`Entity overrides for ${selector} are malformed.`, '\n' + JSON.stringify(overrides, null, 2));
        }
        else {
            result.id = entityId;
            const { channels } = overrides, overrideValues = __rest(overrides, ["channels"]);
            if (channels) {
                result.channels = channels;
            }
            result.overrides = (0, flatten_namespace_1.default)(overrideValues);
        }
        return Object.assign(Object.assign({}, acc), { [entityName]: result });
    }, {});
};
class BrowserS3Provider {
    constructor(app) {
        this.app = app;
    }
    async apply(props) {
        /**
         * Fetch channels and entities. And normalize them so that we don't have to deal with
         * weird shapes in any other code.
         */
        const { channelOverrides, contextOverrides } = await fetchPublicOverrides(this.app, props.environment, props.context);
        const channels = (0, exports.normalizeChannelOverrides)(channelOverrides);
        const entities = normalizeContextOverrides(contextOverrides);
        const overrides = [];
        /**
         * Append STABLE channel overrides to overrides list first so that they
         * are overidden first.
         */
        for (const key in channels.stable) {
            const value = channels.stable[key];
            overrides.push({ key, value, source: `s3-provider/channels:stable` });
        }
        /**
         * Apply custom channel overrides for each entity in order of specificity.
         * For example, if the user is a member of channel "beta", and the
         * current page is a member of channel "gamma", then we should
         * look in custom channels for channels of those names and apply their
         * overrides.
         */
        for (const entityName of exports.ENTITY_ORDER) {
            const entity = entities[entityName];
            if (!entity) {
                continue;
            }
            for (const channelName of entity.channels) {
                const channel = channels.custom[channelName];
                if (!channel) {
                    continue;
                }
                for (const key in channel) {
                    const value = channel[key];
                    overrides.push({
                        key,
                        value,
                        source: `s3-provider/${entity.entity}:${entity.id}/channels:${channelName}`,
                    });
                }
            }
        }
        /**
         * Finally, apply overrides which are specific to individual entities in order of specificity.
         * It is important that we do this in a separate loop from the above so that individual overrides
         * are never overridden by channel specific ones.
         */
        for (const entityName of exports.ENTITY_ORDER) {
            const entity = entities[entityName];
            if (!entity) {
                continue;
            }
            for (const key in entity.overrides) {
                const value = entity.overrides[key];
                overrides.push({ key, value, source: `s3-provider/${entity.entity}:${entity.id}` });
            }
        }
        return overrides;
    }
}
exports.BrowserS3Provider = BrowserS3Provider;
//# sourceMappingURL=browser-s3-provider.js.map